var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-console */
import { select, spawn } from 'redux-saga/effects';
import { getProductsData, getProductsMenuData } from '../../selectors';
import { navigateByMenuProcess } from './_utils/navigation-processes/navigate-by-menu-process';
import { navigateByRouteNameProcess } from './_utils/navigation-processes/navigate-by-routename-process';
import { navigateByRouteUrlProcess } from './_utils/navigation-processes/navigate-by-routeurl-process';
export function navigateToProductWorkerSaga(params) {
    var mappedMenuList, fullFlattenedMenuList, _a, menuName, _b, routeName, _c, routeUrl, store, restParams, externalPackages, error_1;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                console.log('[navigateToProductWorkerSaga]: params', params);
                return [4 /*yield*/, select(getProductsMenuData)];
            case 1:
                mappedMenuList = _d.sent();
                return [4 /*yield*/, select(getProductsData)];
            case 2:
                fullFlattenedMenuList = _d.sent();
                _a = params.menuName, menuName = _a === void 0 ? '' : _a, _b = params.routeName, routeName = _b === void 0 ? '' : _b, _c = params.routeUrl, routeUrl = _c === void 0 ? '' : _c, store = params.store, restParams = __rest(params, ["menuName", "routeName", "routeUrl", "store"]);
                _d.label = 3;
            case 3:
                _d.trys.push([3, 11, , 12]);
                externalPackages = (store.getDependencies() || {}).externalPackages;
                if (!params.menuName) return [3 /*break*/, 5];
                return [4 /*yield*/, spawn(navigateByMenuProcess, __assign(__assign(__assign({}, params), restParams), { menuName: menuName, mappedMenuList: mappedMenuList, fullFlattenedMenuList: fullFlattenedMenuList, externalPackages: externalPackages }))];
            case 4:
                _d.sent();
                return [3 /*break*/, 10];
            case 5:
                if (!params.routeName) return [3 /*break*/, 7];
                return [4 /*yield*/, spawn(navigateByRouteNameProcess, __assign(__assign(__assign({}, params), restParams), { routeName: routeName, mappedMenuList: mappedMenuList, fullFlattenedMenuList: fullFlattenedMenuList, externalPackages: externalPackages }))];
            case 6:
                _d.sent();
                return [3 /*break*/, 10];
            case 7:
                if (!params.routeUrl) return [3 /*break*/, 9];
                return [4 /*yield*/, spawn(navigateByRouteUrlProcess, __assign(__assign(__assign({}, params), restParams), { routeUrl: routeUrl, mappedMenuList: mappedMenuList, fullFlattenedMenuList: fullFlattenedMenuList, externalPackages: externalPackages }))];
            case 8:
                _d.sent();
                return [3 /*break*/, 10];
            case 9: throw new Error('Not corrent params in navigateToProductWorkerSaga');
            case 10: return [3 /*break*/, 12];
            case 11:
                error_1 = _d.sent();
                console.error('navigateToProductWorkerSaga get an error', error_1);
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
